/**
 * Terms of Service Data
 * Contains all content for the Terms of Service page
 */

export const termsSections = [
  {
    id: 1,
    title: "Acceptance of Terms",
    content: [
      "These Terms of Service (\"Terms\") govern your use of the SoundArt website and services (collectively, the \"Service\") operated by SoundArt (\"we,\" \"our,\" or \"us\"). By accessing or using our Service, you agree to be bound by these Terms.",
      "If you disagree with any part of these terms, then you may not access the Service."
    ]
  },
  {
    id: 2,
    title: "Description of Service",
    content: [
      "SoundArt is a music discovery platform that provides:"
    ],
    list: [
      "Artist profiles and biographies",
      "Music news and articles",
      "Concert information and ticket sales",
      "Music-related content and media",
      "Community features and user-generated content"
    ]
  },
  {
    id: 3,
    title: "User Accounts",
    subsections: [
      {
        title: "3.1 Account Creation",
        content: [
          "To access certain features of our Service, you may need to create an account. You agree to:"
        ],
        list: [
          "Provide accurate, current, and complete information",
          "Maintain and update your account information",
          "Keep your password secure and confidential",
          "Accept responsibility for all activities under your account"
        ]
      },
      {
        title: "3.2 Account Termination",
        content: [
          "We reserve the right to suspend or terminate your account at any time for violation of these Terms or for any other reason at our sole discretion."
        ]
      }
    ]
  },
  {
    id: 4,
    title: "Acceptable Use Policy",
    content: [
      "You agree not to use the Service to:"
    ],
    list: [
      "Violate any applicable laws or regulations",
      "Infringe on intellectual property rights",
      "Transmit harmful or malicious code",
      "Harass, abuse, or harm other users",
      "Spam or send unsolicited communications",
      "Attempt to gain unauthorized access to our systems",
      "Interfere with the proper functioning of the Service",
      "Upload content that is illegal, offensive, or inappropriate"
    ]
  },
  {
    id: 5,
    title: "Intellectual Property Rights",
    subsections: [
      {
        title: "5.1 Our Content",
        content: [
          "The Service and its original content, features, and functionality are owned by SoundArt and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws."
        ]
      },
      {
        title: "5.2 User Content",
        content: [
          "You retain ownership of content you submit to the Service. By submitting content, you grant us a non-exclusive, royalty-free, worldwide license to use, modify, and display your content in connection with the Service."
        ]
      },
      {
        title: "5.3 Third-Party Content",
        content: [
          "Our Service may contain content from third parties. We respect intellectual property rights and expect our users to do the same. If you believe your rights have been violated, please contact us."
        ]
      }
    ]
  },
  {
    id: 6,
    title: "Ticket Sales and Payments",
    subsections: [
      {
        title: "6.1 Ticket Purchases",
        content: [
          "When purchasing tickets through our Service:"
        ],
        list: [
          "All sales are final unless otherwise stated",
          "Prices are subject to change without notice",
          "You are responsible for any applicable taxes and fees",
          "We may cancel events due to circumstances beyond our control"
        ]
      },
      {
        title: "6.2 Payment Processing",
        content: [
          "Payments are processed by third-party payment providers. We do not store your payment information. By making a purchase, you agree to the terms of our payment processors."
        ]
      }
    ]
  },
  {
    id: 7,
    title: "Privacy",
    content: [
      "Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service, to understand our practices."
    ]
  },
  {
    id: 8,
    title: "Disclaimers",
    content: [
      "The Service is provided on an \"AS IS\" and \"AS AVAILABLE\" basis. We make no warranties, expressed or implied, including but not limited to:"
    ],
    list: [
      "Warranties of merchantability or fitness for a particular purpose",
      "Warranties regarding the accuracy or reliability of content",
      "Warranties that the Service will be uninterrupted or error-free",
      "Warranties regarding third-party content or services"
    ]
  },
  {
    id: 9,
    title: "Limitation of Liability",
    content: [
      "To the maximum extent permitted by law, SoundArt shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to:"
    ],
    list: [
      "Loss of profits, data, or use",
      "Business interruption",
      "Personal injury or property damage",
      "Damages resulting from unauthorized access to your account"
    ],
    additionalContent: [
      "Our total liability to you for any claims arising from these Terms or the Service shall not exceed the amount you paid us in the 12 months preceding the claim."
    ]
  },
  {
    id: 10,
    title: "Indemnification",
    content: [
      "You agree to defend, indemnify, and hold harmless SoundArt and its officers, directors, employees, and agents from and against any claims, damages, obligations, losses, liabilities, costs, or debt, and expenses (including attorney's fees) arising from your use of the Service or violation of these Terms."
    ]
  },
  {
    id: 11,
    title: "Termination",
    content: [
      "We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.",
      "Upon termination, your right to use the Service will cease immediately. All provisions of the Terms which by their nature should survive termination shall survive termination."
    ]
  },
  {
    id: 12,
    title: "Governing Law",
    content: [
      "These Terms shall be interpreted and governed by the laws of the jurisdiction in which SoundArt operates, without regard to its conflict of law provisions. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in that jurisdiction."
    ]
  },
  {
    id: 13,
    title: "Changes to Terms",
    content: [
      "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.",
      "Your continued use of the Service after any such changes constitutes your acceptance of the new Terms."
    ]
  },
  {
    id: 14,
    title: "Severability",
    content: [
      "If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect."
    ]
  },
  {
    id: 15,
    title: "Entire Agreement",
    content: [
      "These Terms constitute the sole and entire agreement between you and SoundArt regarding the Service and supersede all prior and contemporaneous understandings, agreements, representations, and warranties."
    ]
  },
  {
    id: 16,
    title: "Contact Information",
    content: [
      "If you have any questions about these Terms of Service, please contact us:"
    ],
    contactInfo: {
      email: "legal@soundart.com",
      phone: "(356) 1234 1234",
      address: "112, Roy Buildings, JC Roads, RY"
    }
  }
];

